/**
 * Types of spatial filters
 */
var types = {
  BBOX: 'bbox',
  CIRCLE: 'circle',
  POLYGON: 'polygon'
};

module.exports = types;
